import { Builder } from "@olga-food/schemas/lib/classes/schemas/catalog/Builder";
import { Currency } from "./Currency";
import { OMath } from "./OMath";

export class CatalogHelpers {
  static executeOnSchema(item, callback) {
    for (let field of ["items", "extra_ingredients", "sizes"]) {
      if (item[field] && item[field].length > 0) {
        for (let children of item[field]) {
          CatalogHelpers.executeOnSchema(children, callback);
          callback(children, item, field);
        }
      }
    }
  }

  static calculateSelectedItemPrice(item) {
    if (item.type !== "pizza") {
      const props = ["items", "sizes", "extra_ingredients"];
      // Prevenção de problemas com ponto flutuante: R$ 9.99 => 999
      const price = Math.round((item.price || 0) * 100);
      let total =
        price * (item.selected !== false && item.quantity > 0 ? 1 : 0);

      for (const key of props) {
        if (item[key] && item[key].length > 0) {
          for (const subItem of item[key]) {
            total += CatalogHelpers.calculateSelectedItemPrice(subItem) * 100;
          }
        }
      }

      // console.log({ name: item.name, total, price });
      // Prevenção de problemas com ponto flutuante: R$ 999 => 9.99
      return +OMath.div(OMath.times(total, item.quantity), 100).toFixed(2);
    } else {
      const pizza = Builder.mountSchema(JSON.parse(JSON.stringify(item)));
      return pizza.getPrice();
    }
  }

  static isPromotionalPrice(product) {
    if (!product?.sizes || product?.sizes?.length <= 0) return false;

    return !!product.sizes.find((size) => size.promo_price === true);
  };

  static clearUnselectedItems(item) {
    const props = ["items", "sizes", "extra_ingredients", "doughs", "edges"];
    for (const key of props) {
      const hasQuestions = (item?.items || []).some(
        (children) => children.type === "question"
      );
      if (
        key === "items" &&
        item?.type === "option" &&
        !item?.quantity &&
        hasQuestions
      ) {
        item.selected = false;
        item.items = [];
      }

      if (item[key] && item[key].length > 0) {
        for (const subItemIndex in item[key]) {
          item[key][subItemIndex] = CatalogHelpers.clearUnselectedItems(
            item[key][subItemIndex]
          );
        }

        item[key] = item[key].filter((i) => i.selected !== false);
        if (item[key].length > 0) {
          item.selected = true;
        }
      }
    }
    return item;
  }

  static mountPrice(item) {
    if (item.price > 0) {
      return Currency.formatCurrency(Number(item.price));
    }

    if (item.price >= 0 && item.sizes.length === 0) {
      return Currency.formatCurrency(Number(item.price));
    }

    if (item.type == "pizza" && !item.highlight) {
      const flavorPriceArray = [];
      const doughPriceArray = [];
      for (const dough of item.doughs) {
        doughPriceArray.push(...(dough.sizes.map((s) => s.price) || []));
      }
      //Buscar dentre os sabores os menor preço
      for (const flavor of item.items) {
        flavorPriceArray.push(...(flavor.sizes.map((s) => s.price) || []));
      }

      const minDoughPrice =
        doughPriceArray.length > 0 ? Math.min(...doughPriceArray) : 0;
      const minFlavorPrice =
        flavorPriceArray.length > 0 ? Math.min(...flavorPriceArray) : 0;

      return Currency.formatCurrency(minDoughPrice + minFlavorPrice);
    }

    if (item.sizes.length > 0) {
      const minValue = Math.min(
        ...((item.sizes || []).map((s) => s.price || 0) || [0])
      );

      const questions = item?.items || [];

      const minPricesSum = questions
        .filter(
          (question) =>
            !question.price_method || question?.price_method === "SUM"
        )
        .map((question) => {
          const options = question?.items || [];
          const minOptionPrice =
            options.length > 0
              ? Math.min(
                  ...(options.map(
                    (options) => options.price * question.min
                  ) || [0])
                )
              : 0;

          return minOptionPrice;
        })
        .reduce((total, optionPrice) => total + optionPrice, 0);

      const minPricesMax = questions
        .filter((question) => question?.price_method === "MAX" && question.min)
        .map((question) => {
          const options = question?.items || [];

          const minPrice = options.reduce((minPrice, option) => {
            return minPrice === null
              ? +option.price
              : Math.min(minPrice, +option.price);
          }, null);

          return minPrice;
        })
        .reduce((maxPrice, minQuestionPrice) => {
          return maxPrice === null
            ? +minQuestionPrice
            : Math.max(maxPrice, +minQuestionPrice);
        }, null);

      return Currency.formatCurrency(
        Number(minValue + minPricesSum + minPricesMax)
      );
    }
  }

  static mountOldPrice(item) {
    if (item.old_price > 0) {
      return Currency.formatCurrency(Number(item.old_price));
    }

    if (item.old_price >= 0 && item.sizes.length === 0) {
      return Currency.formatCurrency(Number(item.old_price));
    }

    if (item.type == "pizza" && !item.highlight) {
      const flavorPriceArray = [];
      const doughPriceArray = [];
      for (const dough of item.doughs) {
        doughPriceArray.push(...(dough.sizes.map((s) => s.old_price) || []));
      }
      //Buscar dentre os sabores os menor preço
      for (const flavor of item.items) {
        flavorPriceArray.push(...(flavor.sizes.map((s) => s.old_price) || []));
      }

      const minDoughPrice =
        doughPriceArray.length > 0 ? Math.min(...doughPriceArray) : 0;
      const minFlavorPrice =
        flavorPriceArray.length > 0 ? Math.min(...flavorPriceArray) : 0;

      return Currency.formatCurrency(minDoughPrice + minFlavorPrice);
    }

    if (item.sizes.length > 0) {
      const minValue = Math.min(
        ...((item.sizes || []).map((s) => s.old_price || 0) || [0])
      );

      const questions = item?.items || [];

      const minPricesSum = questions
        .filter(
          (question) =>
            !question.price_method || question?.price_method === "SUM"
        )
        .map((question) => {
          const options = question?.items || [];

          const minOptionPrice =
            options.length > 0
              ? Math.min(
                  ...(options.map(
                    (options) => options.price * question.min
                  ) || [0])
                )
              : 0;

          return minOptionPrice;
        })
        .reduce((total, optionPrice) => total + optionPrice, 0);

      const minPricesMax = questions
        .filter((question) => question?.price_method === "MAX" && question.min)
        .map((question) => {
          const options = question?.items || [];

          const minPrice = options.reduce((minPrice, option) => {
            return minPrice === null
              ? +option.price
              : Math.min(minPrice, +option.price);
          }, null);

          return minPrice;
        })
        .reduce((maxPrice, minQuestionPrice) => {
          return maxPrice === null
            ? +minQuestionPrice
            : Math.max(maxPrice, +minQuestionPrice);
        }, null);

      return Currency.formatCurrency(
        Number(minValue + minPricesSum + minPricesMax)
      );
    }
  }
}
